import React, { PureComponent } from 'react'
import Section                  from '../../../components/Section'
import MajorList                from '../../../components/MajorList'
import './Background.less'

class Background extends PureComponent {
  constructor(props){
    super(props);
    this.state={
        openedId:null,
    }
  }

  handleGoBack() {
      const { history, onBack } = this.props
      typeof onBack === 'function'
          ? onBack()
          : history.push(`/school/list`);
  }
  getMajors(index) {
      const { openedId } = this.state
      if (openedId === index) {
          this.setState({
              openedId: null,
          })
      } else {
          this.setState({
              openedId: index,
          })
      }
  }
  dealFaculties(data){
      if(data){
          let {openedId}=this.state;
          let facultiesList=[];
          Object.keys(data).forEach(i=>{
              let item={};
              item.name=i;
              item.children=data[i];
              facultiesList.push(item);
          });
          return facultiesList.map((i,index)=>
              <div className='classify' key={index}>
                  {i.children.length ==1 && i.children[0].startsWith('(') && i.children[0].endsWith(')') ?
                      <div className="classify-item" >
                          {/*<svg t="1573007158789" className="icon specialMajor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7523" width="10" height="10"><path d="M65.95584 66.06848v891.91936h892.032V66.06848H65.95584z" p-id="7524" fill="#4a4a4a"></path>*/}
                          {/*</svg>*/}
                          <svg className="icon icon-indicator_2">
                              <use xlinkHref="#icon-indicator_2"></use>
                          </svg>
                          <h4>{i.name?i.name:'暂无学院名称'}</h4>
                          <span>暂无专业信息</span>
                      </div>
                      :
                      <div className="classify-item" onClick={this.getMajors.bind(this, index)}>
                          {openedId === index
                              ? <svg className="icon icon-indicator_1">
                                  <use xlinkHref="#icon-indicator_1"></use>
                              </svg>
                              : <svg className="icon icon-indicator_2">
                                  <use xlinkHref="#icon-indicator_2"></use>
                              </svg>}
                          <h4>{i.name?i.name:'暂无学院名称'}</h4>
                          <span>{i.children.length}个专业</span>
                      </div>
                  }
                  {openedId === index &&
                  <div className="major-list">
                      {i.children.map((major,index2)=>{
                          return <div className="major-item" key={index2}>
                              <span>{major}</span>
                          </div>
                      })}
                  </div>}
              </div>
          )
      }
  }
  render() {
    const { detail, match, history } = this.props;
      if (detail) {
        let dtopMajorsArr=detail.dtopMajors?detail.dtopMajors.split('、'):[];
        return (
        <div className="school-background">
            <Section title="学校概况" showMore maxHeight="100px">
                <div className='school-introduction' dangerouslySetInnerHTML={{ __html: detail.introduction?detail.introduction:'暂无数据' }}></div>
            </Section>
          <Section title="硕士/博士点数量" className='doctor-master-num'>
            <div className='job-orientation'>
              <div className="left">
                <div className="left-item master-item" >
                  <div className="num master">{detail.masterNums}</div>
                  <div className="name">硕士点</div>
                </div>
                <div className="left-item doctor-item" >
                    <div className="num doctor">{detail.phdNums}</div>
                    <div className="name">博士点</div>
                </div>
              </div>
              <div className='right'></div>
            </div>
          </Section>
          {detail.dtopMajors &&
            <Section title="双一流建设学科">
                <ul className='dtopMajors'>
                    {detail.dtopMajors}
                    {/*{dtopMajorsArr.map((i,index)=>{*/}
                    {/*    return <li key={index}>{i}</li>*/}
                    {/*})}*/}
                </ul>
            </Section>
          }
            {detail.faculties && JSON.stringify(detail.faculties) != '{}' &&
                <Section title="学校专业设置">
                    <div className="marjor-list-wrapper">
                        {/*<MajorList schoolId={Number(match.params.id)} history={history}/>*/}
                        {this.dealFaculties(detail.faculties)}
                    </div>
                </Section>
            }

          <Section title='联系方式'>
            <div className="contact-school">
              <p>
                <svg className="icon icon-address_icon">
                  <use xlinkHref="#icon-address_icon"></use>
                </svg>
                <span>{detail.address?detail.address:'-'}</span>
              </p>
              <p>
                <svg className="icon icon-email_icon">
                  <use xlinkHref="#icon-email_icon"></use>
                </svg>
                <span>{detail.email?detail.email:'-'}</span>
              </p>
              <p>
                <svg className="icon icon-phone_icon">
                  <use xlinkHref="#icon-phone_icon"></use>
                </svg>
                <span>{detail.phone?detail.phone:'-'}</span>
              </p>
            </div>
          </Section>
          {/* <Section title="下一步，继续解锁不同的学校">
            <div className="school-recommendation">
              <p>我们猜你可能会对这些学校感兴趣：</p>
              <div className="school-card">
                <h3>清华大学</h3>
                <p>点击了解</p>
              </div>
              <div className="school-card">
                <h3>北京大学</h3>
                <p>点击了解</p>
              </div>
              <button onClick={this.handleGoBack.bind(this)}>返回院校列表</button>
            </div>
          </Section> */}
            {
                this.props.hideBottomBtn?
                    null
                    :
                    <Section>
                        <div className="school-recommendation">
                            <button onClick={this.handleGoBack.bind(this)}>返回院校列表</button>
                        </div>
                    </Section>
            }
        </div>
      )
    } else {
      return null
    }
  }
}

export default Background



// WEBPACK FOOTER //
// ./src/pages/School/Detail/Background.js